// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__0B9o7","menu":"styles_menu___mj93","item":"styles_item__DhCjy","active":"styles_active__Ls6yi"};